import { combineEpics } from "redux-observable";
import { success, error } from "react-notification-system-redux";
import * as api from "./api";

export default combineEpics(
  action$ =>
    action$.ofType(api.addPositions.types.success).map(() =>
      success({
        title: "Position added successfully",
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.addPositions.types.failure).map(({ payload }) =>
      error({
        title: payload.message,
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.deletePosition.types.success).map(() =>
      success({
        title: "Position deleted successfully",
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.deletePosition.types.failure).map(({ payload }) =>
      error({
        title: payload.message,
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.addAvailability.types.success).map(() =>
      success({
        title: "Availability added successfully",
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.addAvailability.types.failure).map(({ payload }) =>
      error({
        title: `Error: ${payload.data[0].non_field_errors}`,
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.deleteAvailability.types.success).map(() =>
      success({
        title: "Availability deleted successfully",
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.deleteAvailability.types.failure).map(({ payload }) =>
      error({
        title: payload.data[0].non_field_errors,
        autoDismiss: 15,
        position: "br"
      })
    )
);



// WEBPACK FOOTER //
// ./src/modules/insiders/epic.js